import LoginPage from "../components/pages/login-page"
import OpenPositionsByDaysPage from "../components/pages/open-positions-by-days"
import Deals from "../screens/deals"
import FrequentTrades from "../screens/frequent-trades"
import Home from "../screens/home"
import Logout from "../screens/logout"
import MostLosses from "../screens/most-losses"
import MostProfitable from "../screens/most-profitable"
import OpenPositions from "../screens/open-positions"
import OpenPositionsByDays from "../screens/open-positions-by-days"
import ScamTrades from "../screens/scam-trades"

export const routes = [
  {
    path: "/",
    element: <Deals />,
  },
  {
    path: "/most-profitable",
    element: <MostProfitable />,
  },
  {
    path: "/most-losses",
    element: <MostLosses />,
  },
  {
    path: "/scam-trades",
    element: <ScamTrades />,
  },
  {
    path: "/frequent-trades",
    element: <FrequentTrades />,
  },
  {
    path: "/open-positions",
    element: <OpenPositions />,
  },
  {
    path: "/open-positions-days",
    element: <OpenPositionsByDays />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "*",
    element: <>404 Page not found</>,
  },
]
